import React, { useState } from 'react';

import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const TableClientList = ({ clients, wholeList, sortFunction, campaignId }) => {
  const { t } = useTranslation();

  const [isNameAsc, setIsNameAsc] = useState(true);
  const [isPhoneAsc, setIsPhoneAsc] = useState(true);
  const [isBookingsAsc, setIsBookingsAsc] = useState(true);
  const [isRevenueAsc, setIsRevenueAsc] = useState(true);

  return (
    <table data-bem="TableClientList__table" className="tbl-clients-list fixed-header">
      <thead>
        <tr>
          <th className="text-left cell-cl-name">
            <span
              role="button"
              tabIndex={0}
              onClick={() => {
                sortFunction('user_name', isNameAsc, campaignId);
                setIsNameAsc((prev) => !prev);
              }}
              className="sort-btn"
            >
              {t('campaigns.tableRows.clientName')}
              <div className="client-info-icon">
                <span className="tooltip">
                  <div className="tooltip-centered">{t('campaigns.tableClientList.clientNameTooltipText')}</div>
                </span>
              </div>
            </span>
          </th>

          <th style={{ width: '180px' }} className="text-left">
            <span
              role="button"
              tabIndex={0}
              onClick={() => {
                sortFunction('phone', isPhoneAsc, campaignId);
                setIsPhoneAsc((prev) => !prev);
              }}
              className="sort-btn"
            >
              {t('campaigns.tableRows.mobile')}
            </span>
          </th>

          {fromAnyToBool(wholeList) && (
            <th style={{ width: '130px' }}>
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  sortFunction('appointments_count', isBookingsAsc, campaignId);
                  setIsBookingsAsc((prev) => !prev);
                }}
                className="sort-btn"
              >
                {t('campaigns.tableClientList.bookings')}
              </span>
            </th>
          )}

          {fromAnyToBool(wholeList) && (
            <th style={{ width: '160px' }}>
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  sortFunction('revenue', isRevenueAsc, campaignId);
                  setIsRevenueAsc((prev) => !prev);
                }}
                className="sort-btn"
              >
                {t('campaigns.tableClientList.bookingValue')}
              </span>
            </th>
          )}
        </tr>
      </thead>

      <tbody>
        {clients.map((client) => (
          <tr key={clients.indexOf(client)}>
            <td style={{ width: '200px' }} className="text-left">
              {client.user_name}
            </td>
            <td style={{ width: '180px' }} className="text-left">
              {client.phone}
            </td>

            {fromAnyToBool(wholeList) && <td style={{ width: '130px' }}>{client.appointments_count}</td>}

            {fromAnyToBool(wholeList) && (
              <td style={{ width: '160px' }}>
                {client.revenue ? (
                  <>
                    <CurrencySign />
                    {client.revenue}
                  </>
                ) : (
                  '-'
                )}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableClientList;
